import axios from "../config/axios-chatbot";

// Message protection unlock tokens, stored per registry project in localStorage as
// `protection_project_${projectId}` = {"token": "...", "expiresAt": <ms timestamp>}.

const storageKey = (projectId) => `protection_project_${projectId}`;

export const readFlowProtection = (projectId) => {
  if (!projectId) return null;
  try {
    const entry = JSON.parse(localStorage.getItem(storageKey(projectId)));
    if (entry?.token && entry?.expiresAt > Date.now()) return entry;
    if (entry) localStorage.removeItem(storageKey(projectId));
  } catch (e) {
    // ignore malformed values / blocked storage
  }
  return null;
};

export const writeFlowProtection = (projectId, entry) => {
  if (!projectId) return;
  try {
    if (entry?.token) localStorage.setItem(storageKey(projectId), JSON.stringify(entry));
    else localStorage.removeItem(storageKey(projectId));
  } catch (e) {
    // ignore write errors (e.g. private browsing quota)
  }
};

export const getFlowProtectionToken = (projectId) => readFlowProtection(projectId)?.token || null;

// The registry project whose pages are open: its id is the chatbot backend's default X-Project-Id header (setBaseURL).
// null outside a registry project (old /project/:flowUid pages), where protection is not available.
export const currentProtectionProjectId = () => axios.defaults.headers.common["X-Project-Id"] || null;
